<template>
  <div class="search-price-wrapper--custom">
    <el-tag
      v-if="showMSI"
      type="success"
      effect="plain"
      size="mini"
      class="reserve-with--msi"
    >
      {{ $t(`${base}.msi_up_to`, { value: monthsMSI[monthsMSI.length - 1] }) }}
    </el-tag>

    <div v-if="_hasDiscount" class="price-with-promotions">
      <div v-if="showPerPerson || hasDateRestriction" class="container-before">
        {{ $t(`${base}.before`) }}
        <span class="price-before">{{ `${symbol}${withoutDiscount}` }}</span>
      </div>

      <div class="container-you-save">
        {{ $t(`${base}.you_save`) }}
        <span class="price-you-save">{{
          `${symbol}${discountWithFormat}`
        }}</span>
      </div>
    </div>

    <p
      class="full-price"
      :class="{ 'full-price-with-promotions': _hasDiscount }"
    >
      <span class="symbol">{{ symbol }}</span>
      <span class="price">{{ amount }}</span>
      <span class="container-decimal-currency">
        <span class="decimal">{{ `${decimal}${cents}` }}</span>
        <span class="currency">{{ `${currency}` }}</span>
      </span>
    </p>

    <p
      v-if="showPerPerson || hasDateRestriction"
      class="total-price-per-person"
      >{{ $t(`${base}.total_price_per_person`) }}</p
    >
    <p v-else class="total-price-per-person">{{
      $t(`${base}.total_price_per_person_${promoType}`)
    }}</p>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import LadPricePromoMixin from '@/components/frontends/Price/components/mixin/promo'

export default {
  name: 'LadSearchPriceExperienceCustom',
  filters: { removeEndPoint: (text) => text.replace('.', '') },
  mixins: [LadPricePromoMixin],
  props: {
    item: { type: Object, required: true },
  },
  data() {
    return {
      base: 'experience.price',
      loading: false,
      active: null,
      symbol: '$',
    }
  },
  computed: {
    ...mapState('settings', {
      logo: (state) => state.logo,
      currency: (state) => state.currency,
      paymentPlans: (state) => state.payment_plans,
    }),
    ...mapGetters('device', ['isMobile']),
    isLad() {
      return this.item.is_lad
    },
    isProduct() {
      return ['experience', 'package'].includes(this.item.type)
    },
    showPerPerson() {
      return !(
        this.promoType.startsWith('promo_2x1') ||
        this.promoType.startsWith('promo_3x1')
      )
    },
    hasDateRestriction() {
      return this.promoType.endsWith('_dates') && !this.showDiscountOrPromo
    },
    _hasDiscount() {
      return (
        this.hasDiscount || (!this.showPerPerson && !this.hasDateRestriction)
      )
    },
    _promoDiscount() {
      let promoDiscount = ''
      if (this._hasDiscount) {
        switch (true) {
          case this.promoType.startsWith('promo_2x1'):
            promoDiscount = '2x1'
            break

          case this.promoType.startsWith('promo_3x1'):
            promoDiscount = '3x1'
            break

          default:
            promoDiscount = this.promoDiscount
            break
        }
      }

      return promoDiscount
    },
    // hasTo() {
    //   return Object.keys(this.to).length > 0
    // },
    hasIncludes() {
      const includes = Object.assign({}, this.item.includes)
      delete includes.flights
      return (
        Object.keys(includes).length > 0 &&
        Object.values(includes).some((item) => item === true)
      )
    },
    hasLanguages() {
      const languages = Object.assign({}, this.item.languages)
      delete languages.language_other
      return (
        Object.keys(languages).length > 0 &&
        Object.values(languages).some((item) => item === true)
      )
    },
    hasName() {
      return Reflect.has(this.item, 'name')
    },
    hasDescription() {
      return Reflect.has(this.item, 'description')
    },
    hasDate() {
      return Reflect.has(this.item, 'date')
    },
    hasPrice() {
      return parseFloat(this.item.total_amount) > 0
    },
    price() {
      return this.item.total_amount
    },
    amountCurrency() {
      return this.$options.filters
        .ladFnCurrency(this.price, this.currency, false)
        .subtract(this.discountAmount)
    },
    amountWithoutFormat() {
      return this.amountCurrency.format(false).replace(this.symbol, '')
    },
    amount() {
      return this.showZeroPrice && this.amountCurrency.dollars() === 0
        ? '-'
        : this.amountWithoutFormat.slice(0, -3)
    },
    promotions() {
      return this.item.promotions
    },
    cents() {
      const length = this.amountWithoutFormat.length

      return this.amount === '-' && this.amountCurrency.cents() === 0
        ? '--'
        : this.amountWithoutFormat.slice(-2, length)
    },
    decimal() {
      return this.amountCurrency.s.decimal
    },
    /** meses sin intereses */
    showMSI() {
      const k = this.isLad ? 'lad' : 'others'

      return (this.paymentPlans[k] || []).some((t) => t.percent === 0)
    },
    /** lista meses sin intereses */
    monthsMSI() {
      const k = this.isLad ? 'lad' : 'others'

      return (this.paymentPlans[k] || [])
        .filter((t) => t.percent === 0)
        .map((t) => t.month)
    },
    monthsJoin() {
      const join = this.monthsMSI.join(', ')
      if (this.monthsMSI.length > 1) {
        const index = join.lastIndexOf(',')
        if (index > 0) {
          return (
            join.substring(0, index) +
            ` ${this.$t('search.custom.and')}` +
            join.substring(index + 1)
          )
        }
      }

      return join
    },
  },
  methods: {
    handlerClick() {
      if (typeof this.$gtag !== 'undefined' && this.isProduct) {
        let price = this.item.total_amount

        if (this.item.promotions.length > 0) {
          const promotion = this.item.promotions[0]

          const isCurrentPromotion = Date.parse(promotion.end) >= Date.now()

          if (promotion.rules.length > 0) {
            price = promotion.rules[0].condition.includes(this.currency)
              ? this.item.total_amount * (1 - promotion.value / 100)
              : this.item.total_amount
          } else if (isCurrentPromotion) {
            price = this.item.total_amount * (1 - promotion.value / 100)
          }
        }

        this.$gtag('event', 'eec.productClick', {
          ecommerce: {
            click: {
              products: [
                {
                  name: this.item.title,
                  id: this.item.uuid,
                  price: price === 0 ? '' : price.toFixed(2).toString(),
                },
              ],
            },
          },
          eventCallback() {
            document.location = this.$route.fullPath
          },
          page_title: this.$metaInfo.title,
          page_location: window.location.href,
        })
      }
    },
  },
}
</script>

<style lang="scss">
.search-price-wrapper--custom {
  .wrapper-msi-promotion {
    .discount-value {
      border-radius: 10px;
      border: 1px solid rgba(201, 24, 0, 0.3);
      padding: 3px 5.3px 3px 6px;

      span {
        color: #c91800;
        font-size: 11.2px;
        font-style: normal;
        font-weight: 700;
        line-height: 12.88px; /* 115% */
      }
    }
  }

  .price-with-promotions {
    display: grid;
    gap: 5px;
    margin: 0 0 10px;

    .container-before,
    .container-you-save {
      display: inline-block;
      color: black;
      font-size: 11.2px;
      font-style: normal;
      font-weight: 400;
      line-height: 12.88px; /* 115% */
      text-transform: capitalize;
      max-width: max-content;

      .price-before {
        font-size: 14px;
        font-weight: 700;
        text-decoration: line-through;
      }

      .price-you-save {
        color: #1aa31c;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .container-you-save {
      border-radius: 50px;
      border: 1.5px solid rgba(50, 152, 0, 0.3);
      padding: 4px 12px;
    }
  }

  .price-with-promo-type {
    // margin-top: 10px;

    .container-promo-type {
      display: inline-block;
      color: black;
      font-size: 11.2px;
      font-style: normal;
      font-weight: 400;
      line-height: 12.88px; /* 115% */
      text-transform: capitalize;
      border-radius: 50px;
      border: 1px solid rgba(201, 24, 0, 0.3);
      padding: 4px 12px;

      .price-promo-type {
        color: #c91800;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .full-price {
    margin: 5px 0;

    .symbol {
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 115% */
      vertical-align: top;
    }

    .price {
      color: #000;
      font-size: 30px;
      font-style: normal;
      font-weight: 700;
      line-height: 30px; /* 115% */
    }

    .decimal {
      color: #000;
      font-size: 12.6px;
      font-style: normal;
      font-weight: 400;
      line-height: 14.49px; /* 115% */
      vertical-align: top;
    }

    .currency {
      color: #030303;
      font-size: 10.1px;
      font-style: normal;
      font-weight: 700;
      line-height: 11.59px; /* 114.752% */
      text-transform: uppercase;
    }

    .container-decimal-currency {
      display: inline-flex;
      flex-direction: column;
      vertical-align: top;
      height: 30px;
      place-content: space-between;
    }

    &-with-promotions {
      .price,
      .decimal {
        color: #1aa31c;
      }
    }
  }

  .total-price-per-person {
    margin: 0;
    color: #000;
    font-size: 15.2px;
    font-style: normal;
    font-weight: 700;
    line-height: 12.88px; /* 84.737% */
  }

  .reserve-with {
    display: none;
    color: #000;
    font-size: 15.2px;
    font-style: normal;
    font-weight: 400;
    line-height: 12.88px; /* 84.737% */

    &--price {
      font-weight: 700;
    }

    &--msi {
      border-radius: 50px;
      border: 1.5px solid #c91800;
      color: #c91800;
      font-size: 11.2px;
      font-weight: 700;
      margin-bottom: 10px;
    }
  }

  &.is-drawer {
    .wrapper-msi-promotion,
    .price-with-promotions,
    .total-price-per-person {
      display: none;
    }

    .full-price {
      margin: 0;

      .symbol,
      .price {
        color: #1aa31c;
        font-size: 20px;
        line-height: 12.88px; /* 64.4% */
        font-weight: 700;
        vertical-align: text-top;
      }

      .container-decimal-currency {
        display: unset;
        vertical-align: unset;
        height: unset;
        margin-left: -4px;

        .decimal {
          vertical-align: unset;
          color: #1aa31c;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
        }
      }
    }
  }
}
</style>
